import { Injectable } from '@angular/core';
import dayjs from 'dayjs';

const FORM_DATE_FORMAT = 'YYYY-MM-DD';
const FORM_DATE_FORMAT_US = 'MM/DD/YYYY';
const FORM_DATETIME_FORMAT_US = 'M/D/YYYY h:mm A';

@Injectable()
export class DateFormatService {
  constructor() {
  }

  parseAsStartOfNextDay(value: string): string | Date | undefined {
    const dateValue = dayjs(value).startOf('day');

    if (!dateValue.isValid()) {
      return undefined;
    }

    return dateValue.add(1, 'day').subtract(1, 'second').toDate();
  }

  parseAsStartOfDay(value: string): string | Date | undefined {
    const dateValue = dayjs(value).startOf('day');

    if (!dateValue.isValid()) {
      return undefined;
    }

    return dateValue.toDate();
  }

  formatDateISO(value: string | Date): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      return dayjs(value).format(FORM_DATE_FORMAT);
    }

    return dayjs(value).toISOString().slice(0, 10);
  }

  formatDateTimeISO(value: string | Date): string {
    if (!value) {
      return '';
    }

    return dayjs(value).toISOString();
  }

  formatDateForDisplay(isoJsonDate: Date | string | undefined): string {
    if (!isoJsonDate) {
      return '';
    }

    return dayjs(isoJsonDate).format(FORM_DATE_FORMAT_US);
  }

  formatDateTimeUS(isoJsonDate: Date | string | undefined): string {
    if (!isoJsonDate) {
      return '';
    }

    return dayjs(isoJsonDate).format(FORM_DATETIME_FORMAT_US);
  }

  /**
   * @deprecated The utility grid CSV export no longer uses this format — it renders dates through
   * column formats to match the PDF export (PSQ-10677). Retained for consumer compatibility only.
   */
  formatDateForCsv(isoJsonDate: Date | string | undefined): string {
    return this.formatDateTimeUS(isoJsonDate);
  }
}
